import { Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';

/**
 * Title + description fields shared by {@link EditStepModal} (a real workflow step)
 * and the Custom Editor's step-details modal (a saved Step custom element). Caller
 * owns the surrounding `<Form>` instance/submit handling — this is just the fields.
 */
export function StepDetailsFormFields() {
  const { t } = useTranslation();
  return (
    <>
      <Form.Item
        name="titleEn"
        label={t('workflow.steps.fields.titleEn')}
        rules={[{ required: true, message: t('workflow.steps.fields.titleEnRequired') }]}
      >
        <Input maxLength={120} />
      </Form.Item>
      <Form.Item name="titleFr" label={t('workflow.steps.fields.titleFr')}>
        <Input maxLength={120} />
      </Form.Item>
      {/* The rail / Application Review label. Optional: left blank, both fall back to the Title
          above, which is what every step did before these fields existed. The help text is on the
          English one only — repeating it under the French field reads as a second setting. */}
      <Form.Item
        name="navTitleEn"
        label={t('workflow.steps.fields.navTitleEn')}
        extra={t('workflow.steps.fields.navTitleHelp')}
      >
        <Input maxLength={120} />
      </Form.Item>
      <Form.Item name="navTitleFr" label={t('workflow.steps.fields.navTitleFr')}>
        <Input maxLength={120} />
      </Form.Item>
      <Form.Item name="descriptionEn" label={t('workflow.steps.fields.descriptionEn')}>
        <Input.TextArea rows={2} maxLength={500} />
      </Form.Item>
      <Form.Item name="descriptionFr" label={t('workflow.steps.fields.descriptionFr')}>
        <Input.TextArea rows={2} maxLength={500} />
      </Form.Item>
    </>
  );
}
